import { render, staticRenderFns } from "./JoinsSettingsList.vue?vue&type=template&id=70c612ba&"
import script from "./JoinsSettingsList.vue?vue&type=script&lang=js&"
export * from "./JoinsSettingsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports